<template>
    <div>
        <div class="s-statistics__results__head">
            <h2 class="s-statistics__results__title">
                <template v-if="activeTab === 'byYear'">{{ appData.dictionary.byYearResultsTitle }}</template>
                <template v-else>{{ appData.dictionary.byMonthCountryResultsTitle }}</template>
            </h2>
        </div>
        <div class="s-statistics__table">
            <div v-if="monthlyView" class="s-statistics__tabs-nav">
                <select
                    id="year-select"
                    v-model="activeYear"
                    class="custom-select year-select"
                    @change="setActiveYearData">
                    <option v-for="(year, i) in byMonthYears" :key="'year-' + i" :value="year">
                        {{ year }}
                    </option>
                </select>
            </div>
            <article class="b-article">
                <div v-if="!monthlyView">
                    <table>
                        <thead>
                            <tr>
                                <th>
                                    <span>{{ appData.dictionary.tableYear }}</span>
                                    <br />
                                    &nbsp;
                                </th>
                                <th>
                                    <span>{{ appData.dictionary?.tableKatax }}</span>
                                    <br />
                                    <span class="green-bold">{{ appData.dictionary?.tableCount }}</span>
                                </th>
                                <th>
                                    <br />
                                    <span class="green-bold">
                                        {{ appData.dictionary?.tableValues }}
                                        <a href="#btmNotes">({{ appData.dictionary?.tableValuesNoteIndex }})</a>
                                    </span>
                                </th>
                                <th>
                                    <span>
                                        {{ appData.dictionary?.tableTaktop }}
                                        <a href="#btmNotes">({{ appData.dictionary?.tableTaktopNoteIndex }})</a>
                                    </span>
                                    <br />
                                    <span class="green-bold">{{ appData.dictionary?.tableCount }}</span>
                                </th>
                                <th>
                                    <br />
                                    <span class="green-bold">
                                        {{ appData.dictionary?.tableValues }}
                                        <a href="#btmNotes">({{ appData.dictionary?.tableValuesNoteIndex }})</a>
                                    </span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, row_i) in results.byYear" :key="'row-' + row_i">
                                <td>
                                    <strong>{{ row.year }}</strong>
                                </td>
                                <td>{{ row.katax?.count?.toLocaleString(appData.configuration.locale) }}</td>
                                <td>{{ row.katax?.value?.toLocaleString(appData.configuration.locale) }}</td>
                                <td>{{ row.taktop?.count?.toLocaleString(appData.configuration.locale) }}</td>
                                <td>{{ row.taktop?.value?.toLocaleString(appData.configuration.locale) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-else class="cheques-sticky-table">
                    <table class="th-flex-height cheques-sticky-table__sticky">
                        <thead>
                            <tr>
                                <th style="vertical-align: top; border-bottom: none; padding-bottom: 5px">
                                    <span>{{ appData.dictionary.tableRegion }}</span>
                                </th>
                                <th style="vertical-align: top; border-bottom: none; padding-bottom: 5px">
                                    <span>{{ appData.dictionary?.tablePerfecture }}</span>
                                </th>
                            </tr>
                            <tr>
                                <th style="padding-top: 0px"></th>
                                <th style="padding-top: 0px"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, row_i) in activeYearTableRows" :key="'row-' + row_i">
                                <td>
                                    <strong>{{ row.region }}</strong>
                                </td>
                                <td>{{ row.perfecture }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="th-flex-height cheques-sticky-table__main">
                        <thead>
                            <tr>
                                <th style="vertical-align: top; border-bottom: none; padding-bottom: 5px">
                                    <span>{{ appData.dictionary.tableRegion }}</span>
                                </th>
                                <th style="vertical-align: top; border-bottom: none; padding-bottom: 5px">
                                    <span>{{ appData.dictionary?.tablePerfecture }}</span>
                                </th>
                                <th
                                    v-for="(month, month_i) in activeYearMonths"
                                    :key="'month-' + month_i"
                                    colspan="2"
                                    style="vertical-align: top; border-bottom: none; padding-bottom: 0">
                                    <span>{{ appData.dictionary?.months[month] }}</span>
                                </th>
                            </tr>
                            <tr>
                                <th style="padding-top: 0px"></th>
                                <th style="padding-top: 0px"></th>
                                <template v-for="(month, month_i) in activeYearMonths" :key="'month-' + month_i">
                                    <th style="padding-top: 0px">
                                        <span class="green-bold">{{ appData.dictionary?.tableCountryCount }}</span>
                                    </th>
                                    <th style="padding-top: 0px">
                                        <span class="green-bold">{{ appData.dictionary?.tableCountryValues }}</span>
                                    </th>
                                </template>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, row_i) in activeYearTableRows" :key="'row-' + row_i">
                                <td>
                                    <strong>{{ row.region }}</strong>
                                </td>
                                <td>{{ row.perfecture }}</td>
                                <template v-for="(month, month_i) in activeYearMonths" :key="'month-' + month_i">
                                    <td>
                                        <template v-if="row.monthsData[month]?.count">
                                            {{
                                                row.monthsData[month]?.count?.toLocaleString(
                                                    appData.configuration.locale
                                                )
                                            }}
                                        </template>
                                        <template v-else>-</template>
                                    </td>
                                    <td>
                                        <template v-if="row.monthsData[month]?.value">
                                            {{
                                                row.monthsData[month]?.value?.toLocaleString(
                                                    appData.configuration.locale
                                                )
                                            }}
                                        </template>
                                        <template v-else>-</template>
                                    </td>
                                </template>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </article>
        </div>
        <div v-if="charts.length" class="s-statistics__charts">
            <h3 class="s-statistics__charts__title">
                {{ categoryName }}
            </h3>
            <div v-if="charts.length > 1" class="s-statistics__tabs-nav">
                <a
                    v-for="(chart, i) in charts"
                    :key="'chart-tab-' + i"
                    href="javascript:void(0)"
                    :class="['dotted-link', { active: activeChartTab == chart.id }]"
                    @click="activeChartTab = chart.id">
                    {{ chart.title }}
                </a>
            </div>
            <div class="s-statistics__charts__items">
                <div v-for="(chart, i) in charts" :key="'chart-' + i" class="s-statistics__charts__item">
                    <div v-if="activeChartTab == chart.id || charts.length == 1" class="s-statistics__chart">
                        <line-chart
                            :key="chartsUpdateKey"
                            :labels="chart.labels"
                            :datasets="chart.datasets"
                            :locale="appData.configuration.locale"
                            :is-amount="true"></line-chart>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import statisticsMixins from 'Root/vue/mixins/statisticsMixins'
import LineChart from 'Root/vue/components/LineChart.vue'
import ScrollableTable from 'Root/ui/components/ScrollableTable.js'
import ChequesStickyTable from 'Root/ui/components/ChequesStickyTable.js'
import CustomSelectUI from 'Root/ui/components/CustomSelectUI.js'

export default {
    components: {
        LineChart,
    },

    mixins: [statisticsMixins],

    props: {
        results: {
            type: Object,
            default: () => {
                return {}
            },
        },
        activeTab: {
            type: String,
            default: '',
        },
        category: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            activeChartTab: '',
            activeYear: '',

            byMonthYears: [],
            activeYearMonths: [],
            activeYearTableRows: [],

            charts: [],
            chartsUpdateKey: 0,
        }
    },

    computed: {
        monthlyView() {
            return this.activeTab === 'byMonth'
        },
        categoryName() {
            return this.appData.filters.categories.find((i) => i.value === this.category)?.text
        },
    },

    watch: {
        activeTab() {
            this.iniByMonthYears()
            this.iniChartsData()

            this.chartUpdateKey++

            if (this.activeTab === 'byMonth') {
                this.$nextTick(() => {
                    const yearSelect = this.$el.querySelector('.custom-select.year-select')
                    yearSelect.CustomSelect = new CustomSelectUI(yearSelect)
                })
            }
        },
    },

    mounted() {
        this.iniByMonthYears()
        this.iniChartsData()

        document.querySelectorAll('.b-article table').forEach((elem) => {
            elem.ScrollableTable = new ScrollableTable(elem)
        })
    },

    methods: {
        iniByMonthYears() {
            if (this.monthlyView) {
                this.byMonthYears = []

                this.results[this.activeTab].forEach((resultItem) => {
                    if (!this.byMonthYears.includes(resultItem.year)) {
                        this.byMonthYears.push(resultItem.year)
                    }
                })

                this.byMonthYears.reverse()

                this.activeYear = this.byMonthYears[0]

                this.setActiveYearData()

                this.$nextTick(() => {
                    document.querySelector('.cheques-sticky-table').ChequesStickyTable = new ChequesStickyTable(
                        document.querySelector('.cheques-sticky-table')
                    )
                })
            }
        },

        setActiveYearData() {
            this.activeYearMonths = []
            this.activeYearTableRows = []

            if (this.monthlyView) {
                const activeYearResults = this.results[this.activeTab].filter((i) => i.year === this.activeYear)

                activeYearResults.forEach((resultsItem) => {
                    let activeYearTableRowsIndex = this.activeYearTableRows.findIndex(
                        (tableDataItem) => tableDataItem.perfectureId === resultsItem.perfecture
                    )

                    if (activeYearTableRowsIndex === -1) {
                        this.activeYearTableRows.push({
                            perfectureId: resultsItem.perfecture,
                            perfecture: this.appData.filters.perfectures.find(
                                (perfecture) => resultsItem.perfecture === parseInt(perfecture.value)
                            )?.text,
                            region: this.appData.regions.find((region) => region.id === resultsItem.region)?.text,
                            monthsData: {},
                        })

                        activeYearTableRowsIndex = this.activeYearTableRows.length - 1
                    }

                    this.activeYearTableRows[activeYearTableRowsIndex].monthsData[resultsItem.month] = {
                        count: resultsItem.katax.count,
                        value: resultsItem.katax.value,
                    }

                    if (!this.activeYearMonths.includes(resultsItem.month)) {
                        this.activeYearMonths.push(resultsItem.month)
                    }

                    this.activeYearMonths.sort((a, b) => parseInt(a) - parseInt(b))
                })

                this.$nextTick(() => {
                    if (document.querySelector('.cheques-sticky-table').ChequesStickyTable) {
                        document.querySelector('.cheques-sticky-table').ChequesStickyTable.setStickyTableSize()
                    }
                })
            }
        },

        iniChartsData() {
            if (this.activeTab === 'byMonth') {
                this.charts = []
                return
            }

            const labels = this.monthlyView
                ? this.createChartMonthsLabels(this.results[this.activeTab])
                : this.results[this.activeTab].map((i) => i.year)

            this.charts = [
                {
                    title: this.appData.dictionary.chartCounts,
                    id: 'counts',
                    labels: labels,
                    datasets: [
                        {
                            label: this.appData.dictionary.chartKatax,
                            data: this.results[this.activeTab].map((i) => i.katax?.count),
                        },
                        {
                            label: this.appData.dictionary.chartTaktop,
                            data: this.results[this.activeTab].map((i) => i.taktop?.count),
                        },
                    ],
                },
                {
                    title: this.appData.dictionary.chartValues,
                    id: 'values',
                    labels: labels,
                    datasets: [
                        {
                            label: this.appData.dictionary.chartKatax,
                            data: this.results[this.activeTab].map((i) => i.katax?.value),
                        },
                        {
                            label: this.appData.dictionary.chartTaktop,
                            data: this.results[this.activeTab].map((i) => i.taktop?.value),
                        },
                    ],
                },
            ]

            this.activeChartTab = 'counts'
        },
    },
}
</script>
